import * as React from "react";

const SvgComponent = ({ color = "#1D1D1D", ...props }) => (
  <svg
    width={16}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 11.335a3.333 3.333 0 1 0 0-6.667 3.333 3.333 0 0 0 0 6.667ZM8 .668v1.333M8 14v1.333M2.813 2.813l.947.946M12.24 12.238l.947.947M.667 8H2M14 8h1.333M2.813 13.185l.947-.947M12.24 3.76l.947-.947"
      stroke={color}
      strokeWidth={1.333}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgComponent;
